<div class="assign-court-container">
  <h2>Iniciar Partido</h2>

  <div class="info-match">
    <div><strong>{{player1Name}}</strong> vs <strong>{{player2Name}}</strong></div>
    <div>Categoría: <strong>{{match.category}}</strong></div>
    <div *ngIf="match.code">Código: <strong>{{match.code}}</strong></div>
  </div>

  <!-- QR Code -->
  <div class="qr" *ngIf="match.code && qrConfig">
    <ngx-qrcode-styling
      [config]="qrConfig"
      [template]="qrConfig.template">
    </ngx-qrcode-styling>
  </div>

  <!-- Selector rápido de canchas -->
  <div class="courts-grid">
    <button
      *ngFor="let court of availableCourts"
      class="court-option"
      [class.selected]="form.value.court === court"
      (click)="selectCourt(court)">
      Cancha {{court}}
    </button>
  </div>
  <div class="no-courts" *ngIf="availableCourts.length === 0">
    No hay canchas disponibles
  </div>

  <!-- Input manual de cancha -->
  <form [formGroup]="form" (ngSubmit)="submit()">
    <mat-form-field appearance="fill">
      <mat-label>Cancha</mat-label>
      <input matInput formControlName="court" />
    </mat-form-field>

    <div class="buttons">
      <button mat-flat-button type="submit" [disabled]="form.invalid" color="primary">
        Iniciar Partido
      </button>
      <button mat-stroked-button type="button" (click)="exit()">Cancelar</button>
    </div>
  </form>
</div>
